import {Component, OnInit} from '@angular/core';
import {AuthService} from "./services/auth.service";
import {Router} from "@angular/router";
import {DataService} from "./services/data.service";
import {ApiService} from "./services/api.service";
import {User} from "./type/user";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
    title: string = '';
    loggedUser: User;
    activeRequestNo;

    constructor (
        private authService: AuthService,
        private apiService: ApiService,
        private dataService: DataService,
        private router: Router
    ) {
        this.activeRequestNo = dataService.getActiveRequestNo();
    }

    ngOnInit() {
        this.dataService.getLoggedUser().subscribe(data => {
            this.loggedUser = data;
        });
        this.dataService.getActiveRequestNo().subscribe(data => {
            this.activeRequestNo = data;
        });
    }

    logout() {

        this.apiService.logout().subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
            }
        );
        this.authService.logout();
        this.loggedUser = User;
        this.router.navigateByUrl('/login');

    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts